import moment from "moment";
import api from '@/services/api';
import { saveWeather, getRestoredWeather } from "./weather";
import {
  ACTION_DETAILS,
  ACTION_IPG,
  ACTION_POWER,
  ACTION_CONSUMPTION,
  ACTION_SLOTS,
  ACTION_CONSUMPTION_MONTHLY,
} from './actions';
import { API_MONTH_FORMAT, API_DATE_FORMAT } from './consts';

const actions = {
  async [ACTION_DETAILS] ({ dispatch }, { vector, date: rawDate }) {
    const date = rawDate.format(API_DATE_FORMAT);

    const data = await dispatch('fetchData', {
      url: `/dashboard/details/${vector}/${date}`,
      widget: ACTION_DETAILS,
      vector,
    });

    return data;
  },

  async [ACTION_IPG] ({ dispatch }, { vector, month }) {
    const data = await dispatch('fetchData', {
      url: `/dashboard/ipg/${vector}/${month.format(API_MONTH_FORMAT)}`,
      widget: ACTION_IPG,
      vector,
      isRolling: true,
    });

    return data;
  },

  async [ACTION_POWER] ({ dispatch }, {date: month}) {
    const data = await dispatch('fetchData', {
      url: `/dashboard/power/${month.format(API_MONTH_FORMAT)}`,
      widget: ACTION_POWER,
      vector: ACTION_POWER,
    });

    return data;
  },

  async [ACTION_CONSUMPTION] ({ dispatch }, { vector, date: rawDate }) {
    const date = rawDate.format(API_DATE_FORMAT);
    const data = await dispatch('fetchData', {
      url: `/dashboard/consumption/${vector}/${date}`,
      widget: ACTION_CONSUMPTION,
      vector,
    });

    const firstComingDate = moment(data[0].values[0][0]).format(API_DATE_FORMAT);

    return date !== firstComingDate ?
      { date: firstComingDate, ...data }
      : data;
  },

  async [ACTION_CONSUMPTION_MONTHLY] ({ dispatch }, { vector }) {
    const data = await dispatch('fetchData', {
      url: `/dashboard/consumption/${vector}/monthly`,
      widget: ACTION_CONSUMPTION_MONTHLY,
      vector,
    });

    return data;
  },

  async [ACTION_SLOTS] ({ dispatch }, { date: rawDate }) {
    const date = rawDate.format(API_DATE_FORMAT);
    const data = await dispatch('fetchData', {
      url: `/dashboard/slots/${date}`,
      widget: ACTION_SLOTS,
      vector: ACTION_SLOTS,
    });

    return data;
  },

  async weather ({ rootState }, { latitude, longitude, databaseName }) {
    const restoredWeather = getRestoredWeather(databaseName, latitude, longitude);
    if (restoredWeather) {
      return restoredWeather;
    }

    const { selectedSiteId } = rootState;

    const baseUrl = '/dashboard/weather';
    const url = selectedSiteId ?
      `${baseUrl}/${selectedSiteId}` : baseUrl;

    const weather = await api().get(url, {
      params: {
        lat: latitude,
        lon: longitude,
      },
    })
      .then(handleResponse)
      .then(data => JSON.parse(data));

    saveWeather(weather, databaseName, latitude, longitude);

    return weather;
  },

  getConfigAndUpdateInitialized ({ state, commit }, { widget, vector }) {
    const isInitialized = state.initialized.find(initializedItem => initializedItem.widget === widget && initializedItem.vector === vector);

    const config = isInitialized ? {} : {
      headers: {
        'X-Analytics-AvailableData': 1,
      },
    };

    if (!isInitialized) {
      commit('initialize', { widget, vector });
    }

    return config;
  },

  setIsLocked ({ commit }, payload) {
    commit('setIsLocked', payload);
  },
  setLockedDate ({ commit }, payload) {
    commit('setLockedDate', payload);
  },

  setMaxDateFromResponse ({ commit }, payload) {
    commit('setMaxDateFromResponse', payload);
  },

  getMaxDateFromResponse ({ commit }, payload) {
    return commit('getMaxDateFromResponse', payload);
  },

  async fetchData({ commit, state, dispatch, rootState }, { url, widget, vector, isRolling = false }) {
    const { selectedSiteId } = rootState;
    let sourceUrl = url;

    if (isRolling) {
      sourceUrl = `${sourceUrl}/rolling`;
    }

    if (selectedSiteId) {
      sourceUrl = `${sourceUrl}/${selectedSiteId}`;
    }

    const key = `${sourceUrl}-${widget}-${vector}`;
    if (state.alreadyFetchedData[key]) {
      return state.alreadyFetchedData[key];
    }

    const config = await dispatch('getConfigAndUpdateInitialized', { widget, vector});
    const response = await api().post(sourceUrl, {}, config);

    const { data } = response.data;

    // Add to cache only request without addition configs
    if (!Object.keys(config).length) {
      commit('addData', { key, data });
    }

    return data;
  },

  clear({ commit }) {
    commit('clear');
  },
};

function handleResponse (response) {
  return response.data.data;
}

const initialState = () => {
  return {
    initialized: [],

    maxDateFromResponse: {},

    isLocked: false,
    lockedDate: moment().subtract(1, 'days'),

    alreadyFetchedData: {},
  }
}

export default {
  namespaced: true,
  state: initialState(),
  actions,

  mutations: {
    clear(state) {
      const initialStateData = initialState();
      Object.keys(initialStateData).forEach(key => {
        state[key] = initialStateData[key];
      });
    },

    addData(state, { key, data }) {
      state.alreadyFetchedData[key] = data;
    },

    initialize (state, { widget, vector }) {
      state.initialized.push({ widget, vector });
    },

    setIsLocked (state, isLocked) {
      state.isLocked = isLocked;
    },

    setLockedDate (state, lockedDate) {
      state.lockedDate = lockedDate;
    },

    setMaxDateFromResponse (state, { widget, date }) {
      state.maxDateFromResponse[widget] = date;
    },

    getMaxDateFromResponse (state, widget) {
      return state.maxDateFromResponse[widget];
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/dashboard.js